import React from "react";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/pages/Home";
import GlobeDataTools from "./components/pages/GlobeDataTools";
import Tables from "./components/pages/Tables";
import Table from "./components/pages/Table";
import AIQuery from "./components/pages/AIQuery";
import ImportExportPage from "./components/pages/ImportExportPage";
import AddInterventionPoints from "./components/pages/AddInterventionPoints";
import MatchInterventionPoints from "./components/pages/MatchInterventionPoints";
import ManageSectors from "./components/pages/ManageSectors";
import TargetsAndQualification from "./components/pages/TargetsAndQualification";
import DWHSchemas from "./components/pages/DWHSchemas";
import DWHValidation from "./components/pages/DWHValidation";
import DWHVisualization from "./components/pages/DWHVisualization";
import PreviewImport from "./components/pages/PreviewImport";

function Routes() {
  return (
    <RouterRoutes>
      <Route path="/dwh-schemas" element={<DWHSchemas />} />
      <Route path="/dwh-visualization" element={<DWHVisualization />} />
      <Route path="/preview-import/:fileName" element={<PreviewImport/>} />
      <Route
        path="/*"
        element={
          <Layout>
            <RouterRoutes>
              <Route path="/" element={<Home />} />
              <Route path="/tables" element={<Tables />} />
              <Route path="/tables/:tableName" element={<Table />} />
              <Route path="/ai-query" element={<AIQuery />} />
              <Route path="/import-export" element={<ImportExportPage />} />
              <Route
                path="/add-intervention-points"
                element={<AddInterventionPoints />}
              />
              <Route
                path="/match-intervention-points"
                element={<MatchInterventionPoints />}
              />
              <Route path="/manage-sectors" element={<ManageSectors />} />
              <Route
                path="/targets-and-qualification"
                element={<TargetsAndQualification />}
              />
              <Route path="/dwh-validation" element={<DWHValidation />} />
              <Route path="/gd-tools" element={<GlobeDataTools />} />

            </RouterRoutes>
          </Layout>
        }
      />
    </RouterRoutes>
  );
}

export default Routes;
